"use client";
import { cn } from "@/lib/utils/utils";
import { LucideIcon } from "lucide-react";
import HeaderItem from "./headerItem";
import { Separator } from "@/components/ui/separator";
import React from "react";
import useLocalizer from "@/hooks/useLocalizer";
import Flex from "@/components/core/flex";
import { IconType } from "react-icons/lib";

type Props = {
  items: {
    icon?: LucideIcon | IconType;
    title: string;
    item: string | React.ReactNode;
  }[];
  className?: string;
};
export default function HeaderItemList({ items, className }: Props) {
  const { isRtl } = useLocalizer();
  return (
    <Flex
      className={cn("relative ", className)}
      direction="row"
      justify="between"
      spacing={{ all: 8 }}
      items="center"
    >
      {items.map((item, index) => (
        <div key={index} className="relative inline-block">
          <HeaderItem icon={item?.icon} title={item.title} item={item.item} />
          {index < items.length - 1 && (
            <Separator
              decorative
              orientation="vertical"
              className={cn(
                "h-full bg-primary/50 w-2  skew-10 absolute  top-0 lg:block hidden",
                isRtl ? "-left-5 right-auto" : "-right-5",
              )}
            />
          )}
        </div>
      ))}
    </Flex>
  );
}
